import React from 'react';
import { Box, Container, Grid, Typography, Paper } from '@mui/material';
import { LocationOn as LocationIcon, Phone as PhoneIcon, Email as EmailIcon, Language as WebsiteIcon } from '@mui/icons-material';
import { Reveal, HOME_COLORS, sectionLabelSx } from './common';

export default function MapContactSection({ profile }) {
  const address = profile?.address || '';
  const mapQuery = encodeURIComponent(address || profile?.name || 'Nursing College');

  return (
    <Box id="contact" sx={{ py: { xs: 8, md: 12 }, bgcolor: HOME_COLORS.paper, scrollMarginTop: '80px' }}>
      <Container maxWidth="lg">
        <Reveal>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography sx={sectionLabelSx}>Find Us</Typography>
            <Typography variant="h3" sx={{ fontWeight: 800, color: HOME_COLORS.dark, fontSize: { xs: '2rem', md: '2.6rem' } }}>
              Visit our campus
            </Typography>
          </Box>
        </Reveal>

        <Grid container spacing={4}>
          <Grid item xs={12} md={7}>
            <Reveal sx={{ height: '100%' }}>
              <Box sx={{ borderRadius: 4, overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,77,64,0.14)', height: { xs: 320, md: '100%' }, minHeight: 320 }}>
                <iframe
                  title="College location"
                  src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
                  width="100%"
                  height="100%"
                  style={{ border: 0, display: 'block' }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </Box>
            </Reveal>
          </Grid>
          <Grid item xs={12} md={5}>
            <Reveal delay={100}>
              <Paper elevation={0} sx={{ p: 4, borderRadius: 4, border: '1px solid #dcebe7', height: '100%', bgcolor: '#fff' }}>
                <Typography variant="h6" sx={{ fontWeight: 800, color: HOME_COLORS.dark, mb: 3 }}>Contact information</Typography>

                {address && (
                  <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <LocationIcon sx={{ color: HOME_COLORS.mid, mt: 0.3 }} />
                    <Typography sx={{ color: '#4a5a58' }}>{address}</Typography>
                  </Box>
                )}
                {profile?.contact && (
                  <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <PhoneIcon sx={{ color: HOME_COLORS.mid }} />
                    <Typography sx={{ color: '#4a5a58' }}>{profile.contact}</Typography>
                  </Box>
                )}
                {profile?.email && (
                  <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <EmailIcon sx={{ color: HOME_COLORS.mid }} />
                    <Typography sx={{ color: '#4a5a58' }}>{profile.email}</Typography>
                  </Box>
                )}
                {profile?.website && (
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <WebsiteIcon sx={{ color: HOME_COLORS.mid }} />
                    <Typography sx={{ color: '#4a5a58' }}>{profile.website}</Typography>
                  </Box>
                )}
                {!address && !profile?.contact && !profile?.email && !profile?.website && (
                  <Typography sx={{ color: '#8a9a97' }}>Contact details will be published here soon.</Typography>
                )}
              </Paper>
            </Reveal>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
